<template>
  <div class="main-body">
    <div class="header">服务人员</div>
    <div class="out">

      <div class="search2">

        <el-button type="primary" size="mini" plain @click.native="toggleModalAdd">添加</el-button>


        <div style="float:right">

<!--          <el-select v-model="businessCode" placeholder="请选择商家" style="margin-right:5px">-->
<!--            <el-option-->
<!--                v-for="item in arr_business"-->
<!--                :key="item.businessCode"-->
<!--                :label="item.name"-->
<!--                :value="item.businessCode">-->
<!--            </el-option>-->
<!--          </el-select>-->

          <el-input placeholder="输入姓名" size="mini" v-model="name" clearable style="margin-right:10px;width:120px"></el-input>
          <el-input placeholder="输入身份证号" size="mini" v-model="idCard" clearable style="margin-right:10px;width:180px"></el-input>

          <el-button type="primary" size="mini" icon="el-icon-search" @click="getList(true)">搜索</el-button>

        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData"
                :height="th" border>

        <el-table-column prop="name" fixed="left" label="姓名" width="100"></el-table-column>

        <el-table-column prop="phone" label="APP账号" width="120"></el-table-column>

        <el-table-column prop="idCard" label="身份证" width="200"></el-table-column>
        <el-table-column prop="age" label="年龄" width="60"></el-table-column>
        <el-table-column prop="gender" label="性别" width="60">
          <template slot-scope="scope">
            <span v-if="scope.row.gender == 0">女</span>
            <span v-if="scope.row.gender == 1">男</span>
          </template>
        </el-table-column>
        <el-table-column prop="address" label="地址"></el-table-column>

        <el-table-column prop="serviceStatus" label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">默认</span>
            <span v-if="scope.row.status == 1">正常</span>
            <span v-if="scope.row.status == 2">禁用</span>
          </template>
        </el-table-column>


        <el-table-column prop="createTime" label="创建时间" width="180">
          <template slot-scope="scope">
            {{scope.row.createTime | timefilters }}
          </template>
        </el-table-column>


        <el-table-column fixed="right" label="操作" width="240">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text" size="mini" @click="handlePassword(scope.$index, scope.row)">修改密码</el-button>

            <el-button type="text" size="mini" @click="viewGuiJi(scope.$index, scope.row)">轨迹</el-button>
            <el-button type="text" size="mini" @click="viewVideo(scope.$index, scope.row)">视频通话</el-button>


          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
                         background
                         layout="prev, pager, next"
                         :total="totalItems"
                         :page-size="20"
                         :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd"
         v-bind:arr_business="arr_business" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit"
          v-bind:arr_business="arr_business" v-on:getList="getList"></Edit>

    <GuiJi ref="myGuiJi" v-show="showModalGuiJi" v-on:closeMe="showModalGuiJi=false"></GuiJi>
    <Video ref="myVideo" v-show="showModalVideo" v-on:closeMe="showModalVideo=false"></Video>

    <el-dialog title="密码修改" :visible.sync="pwdDialog" class="dialog" width='400px' center top='30vh'
               :close-on-click-modal='false'>
      <el-input v-model="password" placeholder="请输入登录密码" maxlength="10" minlength="6"
                show-password></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="pwdDialog=false">取 消</el-button>
        <el-button type="primary" @click="editPassword">提交</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>

import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";
import {getGovernmentCode, getStaffCode} from "@/utils/auth";

import Edit from "./EditDisable";
import Add from "./AddDisable";
import GuiJi from "./GuiJi";
import Video from "./Video";


export default {
  name: "Role",
  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month = d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times=d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },
  data() {
    return {

      tableLoading: false,

      showModalAdd: false,
      showModalEdit: false,

      showModalGuiJi: false,
      showModalVideo: false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      serviceStatusValue: ['所有状态', '正常服务', '停止服务'],
      th: 0,


      pwdDialog: false,
      password: '',
      serveCode:'',

      arr_business:[],
      businessCode:'',

      name:'',
      idCard:'',

    }
  },
  components: {
    Add, Edit,GuiJi,Video
  },
  created() {
    this.getBusiness();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  methods: {

    getBusiness(){

      this.$axios({
        method: 'post',
        url: this.$shopUrl+"Business/GovList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
          staffCode: getStaffCode(),
          governmentCode: getGovernmentCode(),
          businessType:6,
        }
      }).then(
          (response) => {
            if (response.data.error === 0) {
              this.arr_business = response.data.data;
              if(this.arr_business.length>0){
                this.businessCode = this.arr_business[0].businessCode;
                this.getList();
              }

            }else if(response.data.error === 1){
              this.$message.error(response.data.message)
            }

          }
      )

    },


    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },

    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1
      var _this=this
      this.tableLoading=true

      this.$axios({
        method: 'post',
        url: this.$shopUrl + "Serve/GovPageBusName",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          businessCode:this.businessCode,
          name: this.name,
          idCard: this.idCard,
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
        }
      }).then((response) => {
        _this.tableLoading=false
        if (response.data.error == 0) {
          this.tableData = response.data.data.pageInfo.list;
          this.totalItems = response.data.data.pageInfo.total;
        }
      }).catch(function (error) {
        _this.tableLoading=false
        console.log(error);
      });
    },



    genders(row) {
      if (row.gender == 0) {
        return "女";
      }
      if (row.gender == 1) {
        return "男";
      }
    },
    serviceStatu(row) {
      if (row.serviceStatus == 0) {
        return "正常服务";
      }
      if (row.serviceStatus == 1) {
        return "停止服务";
      }
    },



    handlePassword(index,row) {
      this.pwdDialog = true;
      this.serveCode = row.serveCode;
      this.password = '';
    },
    editPassword() {

      if (this.password.length < 6) {
        this.$message('密码至少为六位')
        return;
      }

      this.$axios({
        method: 'post',
        url: this.$shopUrl + 'Serve/EditPassword',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          password: this.password,
          serveCode:this.serveCode,
        }
      }).then((response) => {
        //console.log(response);
        if (response.data.error == 0) {
          this.$message('修改成功');
          this.pwdDialog = false
        } else if (response.data.error == 1) {
          this.$message(response.data.message);
        } else {
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },

    viewGuiJi(index, row){
      this.$refs.myGuiJi.init(row);
      this.showModalGuiJi = !this.showModalGuiJi;
    },
    viewVideo(index, row){
      this.$refs.myVideo.init(row);
      this.showModalVideo = !this.showModalVideo;
    },



  }
}
</script>

<style scoped>

</style>
